import React from 'react';
import graphic from '../../../assets/graphic.svg';
import web from '../../../assets/web.svg';
import {Helmet} from "react-helmet";

const Skill = () => {
    return (
        <div className="p-4 lg:ml-40 md:ml-36 sm:ml-20 bg-gray-900">
        <Helmet>
        <title>My Skill</title>
        <meta name='portfolio' content='Mahabuba akter morsana - Skill' />
        </Helmet>
        <div className="p-6">
           <div className="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-10 lg:mt-6 mt-4 items-center">
              <div className='rounded leading-relaxed'>
              <p className='text-gray-200 text-3xl mb-10'>Design & Productivity Tools for Content</p>

              <div className='text-left'>
                <div className="mb-1 text-base font-medium text-white">Adobe Illustrator, Canva, Powerpoint, Word</div>
                <div className="w-full bg-gray-200 rounded-full h-1.5 mb-4">
                <div className="bg-[#976DB2] h-1.5 rounded-full w-5/5"></div>
                </div>

                <div className="mb-1 text-base font-medium text-white">Adobe Photoshop, Adobe After Effects, Excel</div>
                <div className="w-full bg-gray-200 rounded-full h-1.5 mb-4">
                <div className="bg-[#976DB2] h-1.5 rounded-full w-4/5"></div>
                </div>

                <div className="mb-1 text-base font-medium text-white">Adobe Animate, Figma</div>
                <div className="w-full bg-gray-200 rounded-full h-1.5">
                <div className="bg-[#976DB2] h-1.5 rounded-full w-3/5"></div>
                </div>
              </div>
              <img className='w-80 h-80 mx-auto' src={graphic} alt="" />
              </div>

              <div>
              <p className='text-gray-200 text-3xl lg:hidden block'>Web Development</p>

              <img className='w-80 h-80 mx-auto' src={web} alt="" />

              <div className='text-left '>
                <div className="mb-1 text-base font-medium text-white">JavaScript, ES6, HTML5, CSS3, Bootstrap, Tailwind CSS, Daisy UI</div>
                <div className="w-full bg-gray-200 rounded-full h-1.5 mb-4">
                <div className="bg-[#976DB2] h-1.5 rounded-full w-5/5"></div>
                </div>

                <div className="mb-1 text-base font-medium text-white">React, React Router, React hook, React form,  React Bootstrap.
</div>
                <div className="w-full bg-gray-200 rounded-full h-1.5 mb-4">
                <div className="bg-[#976DB2] h-1.5 rounded-full w-4/5"></div>
                </div>

                <div className="mb-1 text-base font-medium text-white">Express JS, MongoDB, Firebase, Node JS, Material UI, Git.</div>
                <div className="w-full bg-gray-200 rounded-full h-1.5 mb-10">
                <div className="bg-[#976DB2] h-1.5 rounded-full w-3/5"></div>
                </div>
              </div>

              <p className='text-gray-200 text-3xl hidden lg:block'>Web Development</p>
              </div>
           </div>
        </div>
     </div>
    );
};

export default Skill;